import app from 'new-ui/app';
import { JOB_STATUS } from 'modules/medicalFiles/constants';
import { setUserData } from 'components/Authentication/actions';

export const getOnJobStatusChange = ({ keepQstack, dispatch }) => (job) => {
  let responseData;

  const { status } = job;
  if (status === JOB_STATUS.UPDATED) {
    if (job.indication) {
      responseData = {
        personal: {
          ...app.user?.personal,
          ...job?.profile.personal,
          condition: job?.indication,
        },
        info: {
          ...app.user?.info,
          ...job?.profile?.info,
          condition: job?.indication,
        },
        condition_profile: {
          ...app.user?.condition_profile,
          ...job?.profile?.condition_profile,
        },
      };
    }
  }
  if (status === JOB_STATUS.COMPLETED || status === JOB_STATUS.COMPLETED_WITH_ALERT) {
    responseData = {
      personal: {
        ...app.user?.personal,
        ...job?.profile?.personal,
        condition: job?.indication,
      },
      info: {
        ...job?.profile.info,
        ...app.user?.info,
        condition: job?.indication,
      },
      condition_profile: {
        ...app.user?.condition_profile,
        ...job?.profile?.condition_profile,
      },
    };
  }

  if (!responseData) {
    return;
  }

  if (keepQstack && responseData?.condition_profile?.qstack && app?.user?.condition_profile?.qstack) {
    responseData.condition_profile.qstack = app.user.condition_profile.qstack;
  }

  dispatch(setUserData(responseData));
};

// eslint-disable-next-line arrow-body-style
export const customizeItems = (items, t) => {
  return (items ?? []).map((item, index) => {
    if (!Array.isArray(item.items)) return { ...item };

    const sortedItems = [...item.items].sort((a, b) => {
      const isA = a.q?.id === 'drugs_received';
      const isB = b.q?.id === 'drugs_received';
      return isA - isB;
    });

    const modifiedItems = sortedItems.map((subitem, i) => {
      let subTitle;
      if (index === 0 && i === 0) {
        subTitle = t('upload.review_step_1');
      }
      if (subitem.q?.id === 'drugs_received') {
        subTitle = t('upload.review_step_2');
      }
      return {
        ...subitem,
        ...(subTitle && { subTitle }),
      };
    });

    return {
      ...item,
      items: modifiedItems,
    };
  });
};
